import { SaveConfig as DLSaveConfig, GetConfig as DLGetConfig, PrepareScreen as DLPrepareScreen, ExecuteSpin as DLExecuteSpin } from './../DL/Roulette'

/**
 * LÓGICA DE NEGOCIO (BL): ROULETTE
 */

const GetRouletteConfig = async (targetScreenId) => {
    return await DLGetConfig(targetScreenId);
};

// const SaveRouletteConfig = async (config) => {
//     // Validamos que las probabilidades sumen un aproximado coherente (ej: 100%)
//     const totalProb = config.prizes.reduce((sum, p) => sum + parseFloat(p.probability || 0), 0);
//     if (Math.abs(totalProb - 100) > 1) {
//         console.warn(`[Roulette BL] Advertencia: Las probabilidades suman ${totalProb}%, se recomienda que sumen 100%`);
//     }
//     return await DLSaveConfig(config);
// };

// Simplificación: Solo guardamos el texto del premio.
// El Frontend asignará los colores y calculará la probabilidad (1/N) al vuelo.
const SaveRouletteConfig = async (config) => {
    // config.prizes solo necesita traer: [{ text: "Premio 1" }, { text: "Premio 2" }]
    return await DLSaveConfig(config);
};

const PrepareRoulette = async (screenId) => {
    if (!screenId || screenId <= 0) return { success: false, message: 'ID de pantalla inválido.' };
    return await DLPrepareScreen(screenId);
};

const SpinRoulette = async (formData) => {
    const payload = {
        targetScreenId: parseInt(formData.targetScreenId, 10) || 0,
        playerName: formData.playerName || "Administrador",
        playerContact: formData.playerContact || ""
    };
    return await DLExecuteSpin(payload);
};

export { GetRouletteConfig, SaveRouletteConfig, PrepareRoulette, SpinRoulette };